import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditLogTable = ({ logs, onRefresh }) => {
  const getSeverityColor = (severity) => {
    const colors = {
      critical: 'var(--color-error)',
      error: 'var(--color-error)',
      warning: 'var(--color-warning)',
      info: 'var(--color-info)'
    };
    return colors?.[severity] || 'var(--color-muted)';
  };

  const getEventTypeIcon = (eventType) => {
    const icons = {
      system_change: 'Settings',
      admin_action: 'UserCheck',
      payment_event: 'CreditCard',
      security_event: 'Shield',
      user_authentication: 'Lock',
      data_modification: 'Database',
      configuration_change: 'Sliders',
      compliance_event: 'FileText'
    };
    return icons?.[eventType] || 'Activity';
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-heading font-semibold text-foreground">Audit Logs</h3>
        <span className="text-sm text-muted-foreground">{logs?.length || 0} events</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Event</th>
              <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Description</th>
              <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">User</th>
              <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Severity</th>
              <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {logs?.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center py-12">
                  <Icon name="FileText" size={48} className="mx-auto mb-4 text-muted-foreground" />
                  <p className="text-muted-foreground">No audit logs found</p>
                </td>
              </tr>
            ) : (
              logs?.map((log) => (
                <tr key={log?.id} className="border-b border-border hover:bg-muted/50 transition-colors">
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-2">
                      <Icon name={getEventTypeIcon(log?.event_type)} size={16} className="text-primary" />
                      <span className="text-sm font-medium text-foreground">
                        {log?.event_type?.replace(/_/g, ' ')?.toUpperCase()}
                      </span>
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    <p className="text-sm text-foreground line-clamp-2">{log?.event_description}</p>
                  </td>
                  <td className="py-3 px-4">
                    <p className="text-sm text-foreground">{log?.user?.full_name || 'System'}</p>
                  </td>
                  <td className="py-3 px-4">
                    <span
                      className="px-2 py-1 rounded text-xs font-medium"
                      style={{
                        backgroundColor: `${getSeverityColor(log?.severity)}15`,
                        color: getSeverityColor(log?.severity)
                      }}
                    >
                      {log?.severity}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <p className="text-sm text-muted-foreground">
                      {new Date(log?.created_at)?.toLocaleString()}
                    </p>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditLogTable;